import { USER_ROLES } from "../all-types";
import { sidebarExtraUrls, sidebarUrls } from "../constants";


export const getSideBarByRole = (role: USER_ROLES) => {

    switch(role) {
        case USER_ROLES.ADMIN:
        case USER_ROLES.MANAGER:
            return sidebarUrls;
        case USER_ROLES.CASHIER:
        case USER_ROLES.SALES_REPRESENTATIVE:
        case USER_ROLES.WAITER:
            return {
                // "AppDownload" : sidebarUrls["AppDownload"],
                // "Order" : sidebarUrls["Order"],
                "Kitchen" : sidebarUrls["Kitchen"],
                "KitchenStats" : sidebarUrls["KitchenStats"],
                "Printer" : sidebarExtraUrls["Printer"]
            }
        default: return {
            "AppDownload" : sidebarUrls["AppDownload"],
            "Order" : sidebarUrls["Order"],
        }

    }
}